module.exports = __webpack_public_path__ + "img/portfolio1m-m@2.3475ae0c.jpg";